/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTToast } from './toast';
export type { KTToastConfigInterface, KTToastInterface } from './types';
